// extracted by mini-css-extract-plugin
module.exports = {"root":"NothingFound_root__je0kZ","content":"NothingFound_content__Wl4OK","title":"NothingFound_title__mClEi","subtitle":"NothingFound_subtitle__I60Lr"};